import { render } from "./ProfileCardChip.vue?vue&type=template&id=0629dcd6&scoped=true"
import script from "./ProfileCardChip.vue?vue&type=script&lang=ts"
export * from "./ProfileCardChip.vue?vue&type=script&lang=ts"

import "./ProfileCardChip.vue?vue&type=style&index=0&id=0629dcd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0629dcd6"

export default script